import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  List,
  MenuItem,
  Radio,
  Typography,
  Button,
} from "@mui/material";

interface Variant {
  variant_id: string;
  value: string;
}

interface VariantSelectorDialogProps {
  openModal: boolean;
  handleModalClose: () => void;
  variants: Variant[] | null;
  selectedVariant: string | null;
  handleVariantSelect: (variantId: string) => void;
  handleAddToCart: () => void;
}

const VariantSelectorDialog: React.FC<VariantSelectorDialogProps> = ({
  openModal,
  handleModalClose,
  variants,
  selectedVariant,
  handleVariantSelect,
  handleAddToCart,
}) => {
  const defaultVariant = { variant_id: 1, value: "Default Variant" };
  const displayedVariants =
    variants && variants.length > 0 ? variants : [defaultVariant];

  return (
    <Dialog
      open={openModal}
      onClose={handleModalClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          borderRadius: "5px",
          padding: "10px",
        },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "1.0rem",
            padding: "8px 0",
            color: "grey",
            borderBottom: "1px solid #e0e0e0",
            textTransform: "uppercase",
          }}
        >
          Select a Variant
        </Box>
      </DialogTitle>
      <DialogContent>
        <List
          sx={{
            maxHeight: "300px",
            padding: "0",
          }}
        >
          {displayedVariants.map((variant) => (
            <MenuItem
              key={variant.variant_id}
              onClick={() => handleVariantSelect(variant.variant_id)}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderRadius: "8px",
                marginBottom: "8px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                  transform: "scale(1.02)",
                  transition: "0.2s ease-in-out",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Radio
                  checked={selectedVariant === variant.variant_id}
                  value={variant.variant_id}
                  sx={{
                    color: "#1467a5",
                    "&.Mui-checked": {
                      color: "#1467a5 ",
                    },
                  }}
                />
                <Typography sx={{ fontSize: "1rem", fontWeight: "500" }}>
                  {variant.value}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleModalClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleAddToCart}
          disabled={!selectedVariant}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VariantSelectorDialog;
